import React from 'react'
import ReactDOM from 'react-dom'
import {
  BrowserRouter as Router,
} from 'react-router-dom'
import routes from '~/routes'
import { matchRoutes } from 'react-router-config'

import App from './app'
//import { store } from './store'
import { ParallaxProvider } from 'react-scroll-parallax';
import { Provider } from 'react-redux'
import configureStore from './configureStore'

import ReactGA from 'react-ga'

//store.getFM.next('APP')
const state = window.__STATE__;
delete window.__STATE__;

const reduxStore = configureStore(state)

ReactGA.initialize('UA-18523280-1')
ReactGA.pageview(window.location.pathname + window.location.search)

ReactDOM.hydrate(
  <Provider store={reduxStore}>
    <Router>
      <ParallaxProvider>
        <App />
      </ParallaxProvider>
    </Router>
  </Provider>,
  document.getElementById("app")
)
